module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "cre"
    }
  }, [_c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("THE")]), _vm._v(" W"), _c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("HITE")]), _vm._v(" H"), _c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("OUSE")]), _vm._v(" D"), _c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("URING")]), _vm._v(" L"), _c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("INCOLN’S")]), _vm._v(" P"), _c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("RESIDENCY")])]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1")]), _vm._v(" Lincoln’s office connected by a private passageway to Family Living Room")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("2")]), _vm._v(" Reception Room")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3")]), _vm._v(" Part of West Hall")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4")]), _vm._v(" Office stairs")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5")]), _vm._v(" Bedroom for Nicolay and Hay")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6")]), _vm._v(" Hay’s office")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7")]), _vm._v(" West Hall")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("8")]), _vm._v(" Nicolay’s office")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9")]), _vm._v(" Family Living Room")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10")]), _vm._v(" Mary Lincoln’s bedroom")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11-13")]), _vm._v(" Lincoln’s bedroom/dressing room suite")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14")]), _vm._v(" Grand stairs and landing")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("15")]), _vm._v(" Tad’s bedroom")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16")]), _vm._v(" Willie’s (Prince of Wales) bedroom")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17")]), _vm._v(" Service stairs")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("18-20")]), _vm._v(" Pair of bedrooms divided by a corridor from whose window Lincoln spoke")]), _vm._v(" "), _c('p', {
    staticClass: "bnl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21")]), _vm._v(" Central Hall for family’s private living quarters")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "593",
      "src": "images/pg8.jpg",
      "width": "400"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479347a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/credits.vue
// module id = 66
// module chunks = 0